import { createSlice } from '@reduxjs/toolkit';

const easyBuySlice = createSlice({
  name: 'easyBuy',
  initialState: {
    loading: false,
    easyBuyData: null,
    error: null,
    success: false
  },
  reducers: {
    getEasyBuyRequest(state) {
      state.loading = true;
      state.error = null;
      state.success = false;
    },
    getEasyBuySuccess(state, action) {
      state.loading = false;
      state.easyBuyData = action.payload;
      state.success = true;
    },
    getEasyBuyFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    getEasyBuyReset(state) {
      state.loading = false;
      state.error = null;
      state.easyBuyData = null;
      state.success = false;
    }
  },
});

export const {
  getEasyBuyRequest,
  getEasyBuySuccess,
  getEasyBuyFailure,
  getEasyBuyReset
} = easyBuySlice.actions;

export default easyBuySlice.reducer;
